import config from '../../config';
class CostsSaveBannerController {
  constructor(
    Authentication,
    PersonaCollection,
    AccountService,
    SlingAnalytics,
    $timeout,
    $state,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      AccountService,
      SlingAnalytics,
      $timeout,
      $state,
      $scope,
    });
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  async init() {
    if (!config.OT_COSTS_BANNER_ENABLED) {
      return;
    }

    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;

    this.user = { ...this.Authentication.user };
    this.saveClientFlags = this.Authentication.saveClientFlags;

    this.$scope.$watch(
      'ctrl.Authentication.user.settings.clientFlags.canShowOTCostsBanner',
      (newValue, oldValue) => {
        if (newValue && !oldValue) {
          this.user = { ...this.Authentication.user };
        }
      }
    );
  }
}

export default {
  template: `
    <r-costs-save-banner ng-if="!!ctrl.user"
      user="ctrl.user"
      save-client-flags="ctrl.saveClientFlags(flags)">
    </r-costs-save-banner>
    `,
  controller: CostsSaveBannerController,
  controllerAs: 'ctrl',
};
